export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const DECREASE_CART_QTY = "DECREASE_CART_QTY";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_CLEAR_ITEMS = "CART_CLEAR_ITEMS";
export const CART_SAVE_BILLING_ADDRESS = "CART_SAVE_BILLING_ADDRESS";
export const CART_SAVE_PAYMENT_METHOD = "CART_SAVE_PAYMENT_METHOD";
